var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Label, InputHintError, OptionalTag } from "./Addons";
import Checkbox from "./Checkbox";
import { Col } from "../grid";
import React from 'react';
import { styled, css, mq } from "../../utils";
var Container = styled.ul(function (_a) {
    var _b = _a.theme, colors = _b.colors, space = _b.space;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    padding: ", ";\n    background-color: ", ";\n    margin: 0;\n    border: 1.5px solid ", ";\n    border-radius: 16px;\n\n    li {\n      list-style-type: none;\n      padding-bottom: 0.5rem;\n    }\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    padding: ", ";\n    background-color: ", ";\n    margin: 0;\n    border: 1.5px solid ", ";\n    border-radius: 16px;\n\n    li {\n      list-style-type: none;\n      padding-bottom: 0.5rem;\n    }\n  "])), space[3], colors.white, colors.primary);
});
var StyledCheckBox = styled(Checkbox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 0 !important;\n\n  .checkbox {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 25px;\n    min-height: 25px;\n    width: 25px;\n    min-width: 25px;\n  }\n\n  /* Style the checkmark/indicator */\n  .checkbox:after {\n    height: 12px;\n    margin-bottom: 5px;\n    margin-left: 0;\n  }\n\n  p.label {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n\n    ", ";\n  }\n"], ["\n  margin-bottom: 0 !important;\n\n  .checkbox {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 25px;\n    min-height: 25px;\n    width: 25px;\n    min-width: 25px;\n  }\n\n  /* Style the checkmark/indicator */\n  .checkbox:after {\n    height: 12px;\n    margin-bottom: 5px;\n    margin-left: 0;\n  }\n\n  p.label {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n\n    ", ";\n  }\n"])), mq({ width: ['auto', '120px', 'auto'] }));
var CheckboxGroup = function (_a) {
    var options = _a.options, label = _a.label, error = _a.error, optional = _a.optional, initialValue = _a.value, props = __rest(_a, ["options", "label", "error", "optional", "value"]);
    return (React.createElement(React.Fragment, null,
        label && (React.createElement(Label, { ml: "large", mb: "small" },
            label,
            optional && React.createElement(OptionalTag, null))),
        React.createElement(Container, null, options.map(function (_a, index) {
            var value = _a.value, label = _a.label;
            return (React.createElement(Col, { width: [1, 1 / 3], key: "".concat(label, "-").concat(index) },
                React.createElement("li", null,
                    React.createElement(StyledCheckBox, __assign({}, props, { label: label, value: value, checked: (initialValue === null || initialValue === void 0 ? void 0 : initialValue.includes(value)) || false })))));
        })),
        error && React.createElement(InputHintError, { validation: true, error: error, hint: "" })));
};
export default CheckboxGroup;
var templateObject_1, templateObject_2;
//# sourceMappingURL=CheckboxGroup.js.map